export default __webpack_public_path__ + "static/media/Todomoda.ab9fcf0c.jpg";